import { FunctionComponent } from "react";
import styles from "./AdminTopMenu.module.css";

const AdminTopMenu: FunctionComponent = () => {
    return (
        <div>
            <div className={styles.container}>
                <img className={styles.manaberlogoCopy1} alt="" src="/manaberlogo.png" />
            </div >
            <div className={styles.separator}></div>
        </div>
    );
};

export default AdminTopMenu;
